import { IProduct } from '../types/shoppe';

export default ( product: IProduct, k: number = 0 ): string =>
  `${product.effectiveName} by ${product.merchant.name}${k > 0 ? ` - Alternate image ${k}` : ''}`;
